export const CORE_CHAT_NAME = "core-chat";

export enum CoreChatComponent {
  ContactSupportDetails = "ContactSupportDetails",
  ContactSupportOption = "ContactSupportOption",
}
